import React from "react";
export default function CheckBoxIcon() {
  return (
    <div style={{ marginLeft: "10px" }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.96 2.5H5.04C3.6372 2.5 2.5 3.6372 2.5 5.04V14.96C2.5 16.3628 3.6372 17.5 5.04 17.5H14.96C16.3628 17.5 17.5 16.3628 17.5 14.96V5.04C17.5 3.6372 16.3628 2.5 14.96 2.5ZM16.1 14.96C16.1 15.5896 15.5896 16.1 14.96 16.1H5.03999C4.41039 16.1 3.89999 15.5896 3.89999 14.96V5.04C3.89999 4.41039 4.41039 3.9 5.03999 3.9H14.96C15.5896 3.9 16.1 4.41039 16.1 5.04V14.96ZM13.57 8.5C13.8446 8.2232 13.8446 7.7768 13.57 7.5C13.2944 7.23199 12.8556 7.23199 12.58 7.5L9.03 11.03L7.43 9.41C7.25136 9.23136 6.991 9.1616 6.74698 9.22698C6.50297 9.29237 6.31237 9.48297 6.24698 9.72698C6.1816 9.971 6.25136 10.2314 6.43 10.41L8.5 12.5C8.637 12.6313 8.82029 12.7031 9.01 12.7C9.19321 12.7 9.36913 12.6282 9.5 12.5L13.57 8.5Z"
          fill="#12344D"
        />
      </svg>
    </div>
  );
}
